/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { prospectedPropertyResponseDtoSchema } from "./prospectedPropertyResponseDtoSchema";
import { z } from "zod/v4";

export const sellOrRentOutLeadInterestResponseDtoSchema = z.object({
    "type": z.enum(["SELL", "RENT_OUT"]),
get "prospectProperty"(){
                return prospectedPropertyResponseDtoSchema
              }
    })